import axiosIns from '@/libs/axios'

const ROOT_URL = '/current_accounts'
export default {
  namespaced: true,
  state: {
    dataList: [],
    counters: [],
    customersList: [],
    dataCounts: 0,
    dataItem: {
      id: null,
      cnumber: null,
      pdate: null,
      content: null,
      amount: null,
      id_customers: null,
      id_customer_users: null,
      id_users: null,
      lines: [],
      submitButton: false,
    },
    dataSave: {
      message: null,
      status: null,
      id: null,
    },
  },
  getters: {
    dataList(state) {
      return state.dataList
    },
    dataCounts(state) {
      return state.dataCounts
    },
    counters(state) {
      return state.counters
    },
    dataItem(state) {
      return state.dataItem
    },
    dataSaveStatus(state) {
      return state.dataSave
    },
    getCustomersList(state) {
      return state.customersList
    },
  },
  mutations: {
    SET_DATA_LIST(state, data) {
      state.dataList = data
    },
    SET_DATA_ITEM(state, data) {
      state.dataItem = data
    },
    SET_DATA_COUNTS(state, data) {
      state.dataCounts = data
    },
    SET_DATA_COUNTERS(state, data) {
      state.counters = data
    },
    SET_DATA_SAVE(state, data) {
      state.dataSave = data
    },
    CUSTOMERS_LIST(state, data) {
      state.customersList = data
    },
    RESET_DATA_ITEM(state) {
      state.dataItem = {
        id: null,
        cnumber: null,
        pdate: null,
        content: null,
        amount: null,
        id_customers: null,
        id_customer_users: null,
        id_users: null,
        lines: [],
        submitButton: false,
      }
    },
  },
  actions: {
    getDataList({ commit }, params) {
      const data = JSON.stringify(params)
      axiosIns
        .post(ROOT_URL, data)
        .then(response => {
          commit('SET_DATA_LIST', response.data.data)
          commit('SET_DATA_COUNTS', response.data.count)
          commit('SET_DATA_COUNTERS', response.data.counters)
        })
        .catch(error => console.error(error))
    },
    getDataItem({ commit }, id) {
      const data = JSON.stringify({
        where: {
          'current_accounts.id': id,
        },
        array: false,
      })
      return axiosIns
        .post(ROOT_URL, data)
        .then(response => {
          commit('SET_DATA_ITEM', response.data.data)
          return response.data.data
        })
        .catch(error => console.error(error))
    },
    customersSearch({ commit }, params) {
      const data = JSON.stringify(params)
      axiosIns
        .post(`${ROOT_URL}/getCustomers`, data)
        .then(response => {
          commit('CUSTOMERS_LIST', response.data.data)
        })
        .catch(error => console.error(error))
    },
    saveData({ commit }, postData) {
      const data = JSON.stringify(postData)
      return axiosIns
        .post(`${ROOT_URL}/saveData`, data)
        .then(response => {
          commit('SET_DATA_SAVE', response.data)
          return response.data
        })
        .catch(error => console.error(error))
    },
    removeData({ commit }, id) {
      return axiosIns
        .post(`${ROOT_URL}/deleteData`, { id })
        .then(response => {
          commit('SET_DATA_SAVE', response.data)
          return response.data
        })
        .catch(error => console.error(error))
    },
  },
}
